import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../service/loader.service';


@Component({
  selector: 'app-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
})
export class UnauthorizedComponent implements OnInit {

  constructor(private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.loaderService.hide()
  }

}
